import React from "react";
import "./Services.css";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import Homepage_services_card from "../../Common_Component/Homepage_services_card/Homepage_services_card";

function Services() {
  const navigate = useNavigate();

  const handleNavigation = (tabKey) => {
    navigate("/services", { state: { tabKey } }); // Pass tabKey as state
  };
  return (
    <>
      <section className="Services">
        <div className="container">
          <h1 className="title heading">Services</h1>

          <div className="Homepage_services_card_swiper_holder">
            <Swiper
              pagination={true}
              modules={[Pagination]}
              slidesPerView={4}
              spaceBetween={20}
              className="mySwiper Homepage_services_card_swiper"
              breakpoints={{
                // when window width is >= 280px
                280: {
                  slidesPerView: 2,
                  spaceBetween: 10,
                },

                // when window width is >= 320px
                320: {
                  slidesPerView: 2,
                  spaceBetween: 10,
                },

                // when window width is >= 575px
                485: {
                  slidesPerView: 2,
                  spaceBetween: 10,
                },
                // when window width is >= 640px
                640: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                // when window width is >= 768px
                768: {
                  slidesPerView: 3,
                  spaceBetween: 20,
                },
                // when window width is >= 1024px
                1024: {
                  slidesPerView: 4,
                  spaceBetween: 20,
                },
                // when window width is >= 1280px
                1280: {
                  slidesPerView: 4,
                  spaceBetween: 20,
                },
              }}
            >
              <SwiperSlide onClick={() => handleNavigation("Video_Wala_Bus_Stand")}>
                <Homepage_services_card
                  imgSrc={
                    "/Assets/Images/Home/Homepage_services_card/new_img1.png"
                  }
                  cradHeadting={"Videowala Bus Stand"}
                />
              </SwiperSlide>
              <SwiperSlide onClick={() => handleNavigation("Multimedia_Advertising")}>
                <Homepage_services_card
                  imgSrc={
                    "/Assets/Images/Home/Homepage_services_card/new_img2.png"
                  }
                  cradHeadting={"Multimedia Advertising"}
                />
              </SwiperSlide>
              <SwiperSlide onClick={() => handleNavigation("Digital_Media")}>
                <Homepage_services_card
                  imgSrc={
                    "/Assets/Images/Home/Homepage_services_card/new_img3.png"
                  }
                  cradHeadting={"Digital Media Services"}
                />
              </SwiperSlide>

              {/* <SwiperSlide onClick={() => handleNavigation("Print_Media")}>
                <Homepage_services_card
                  imgSrc={
                    "/Assets/Images/Home/Homepage_services_card/new_img4.png"
                  }
                  cradHeadting={"Print Media Services"}
                />
              </SwiperSlide> */}

              <SwiperSlide onClick={() => handleNavigation("Branding")}>
                <Homepage_services_card
                  imgSrc={
                    "/Assets/Images/Home/Homepage_services_card/new_img5.png"
                  }
                  cradHeadting={"Branding Services"}
                />
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </section>
    </>
  );
}

export default Services;
